import React, { useContext } from "react";
import AppUIModel from "models/appUIModel";
import { HeaderContainer, LogOutButton } from "../SlideMenu.styles";
import Avatar from "../../../Avatar";

export default function MenuHeader() {
  const { t, userData, menuWidth, onLogout } = useContext(AppUIModel.Context);

  return (
    <HeaderContainer $menuWidth={menuWidth}>
      <Avatar user={userData} showPhone={false} sm isSystemUser />
      <LogOutButton onClick={() => onLogout()}>
        {t("Button.logout")}
      </LogOutButton>
    </HeaderContainer>
  );
}
